<template>
	<b-modal ref="profile_modal"
			 size="xl"
			 bodyClass="p-0"
			 v-bind:no-close-on-backdrop=true
			 :hide-header=true
			 v-model="is_show_modal"
			 :dialogClass=dialog_class_draw>

		<template v-slot:modal-header="{ close }">
			<!-- Emulate built in modal header close button action -->
			<b-button size="sm" variant="outline-danger" @click="close()">
				Close Modal
			</b-button>
		</template>

		<!-- BODY -->
		<div id="panel_user_list" class="panel mb-0 border-bottom-0 shadow-none">
			<div class="panel-hdr border-faded border-top-0 border-right-0 border-left-0 shadow-0">
				<h2 >
					<span class="fw-300">ID:{{this.order.id}} | {{order_code}}</span>
				</h2>
				<div class="panel-toolbar pr-3 pb-2 align-self-end">
					<button class="btn btn-panel bg-transparent fs-xl w-auto h-auto rounded-0 waves-effect waves-themed" v-on:click="close()">
						<i class="fal fa-times"></i>
					</button>
				</div>
			</div>

			<div class="panel-container show">
				<b-overlay :show="is_load" rounded="sm">
					<div class="panel-content" v-if="order.id > 0">
						<div class="d-flex flex-column align-items-center justify-content-center p-4">
							<h5 class="mb-0 fw-700 text-center mt-3">
								{{order_code}}
							</h5>

							<h6>
								{{order_added}}
							</h6>
						</div>
						<div>
							<b-tabs content-class="mt-3">
								<b-tab v-for="(tab,index) in default_tabs" @click="set_active(index)"
									   :disabled="tab.disabled"
									   :title="get_tab_title(tab)"
									   :key="index"
									   :active="tab.is_active"
								>
									<template slot="title">
										{{get_tab_title(tab)}}
										<b-spinner type="grow" small v-if="tab.is_load"></b-spinner>
									</template>
									<component v-bind:is="tab.index" :order="order"></component>
								</b-tab>
							</b-tabs>
						</div>
					</div>
				</b-overlay>
			</div>
			<!--FOOTER -->
		</div>

		<template v-slot:modal-footer="{close}">
			<div class="modal-footer">
				<button type="button" v-on:click="close_mod" class="btn btn-secondary waves-effect waves-themed">
					{{__t('CLOSE')}}
				</button>

			</div>
		</template>
	</b-modal>
</template>

<script>

import Info_field from "../../sys/info_field";
import Order_info from './tabs/order_info';
import Order_products from './tabs/order_products';
import order_requests from "./tabs/order_requests.vue";
import order_client from "./tabs/order_client.vue";
import order_action from "./tabs/order_action";
import order_delivery from "./tabs/order_delivery.vue";
import order_log from "./tabs/order_log.vue";

export default {
	name: "order_modal",
	components : {
        Order_info,
        Info_field,
        Order_products,
        order_requests,
        order_client,
        order_action,
        order_log,
        order_delivery
	},
	props : {
		modal_position : {
			type : String,
			default : "left"
		},
		event_name : {
			type : String,
			default : "order_modal"
		},
		show_client_tab : {
			type : Boolean,
			default : true
		},
	},
	data() {
		return  {
			is_show_modal : false,
			is_load_adv : false,
			is_load : false,
			order: {
				id : 0,
                "order": {
                    "id": 0,
                    "uniq_id": "",
                    "order_code": "",
                    "transaction_id": "0",
                    "pickup_code": ""
                },

				title : "",
				uniq_id : "",
                pos_provider: "",
				order_code : ""
			},
			tabs:[
                {"title":this.__t("MAIN_SETTINGS"),"is_active":false,"is_load":false,"index":"order_info","html":""},
                {"title":this.__t("ORDER.PRODUCT"),"is_active":false,"is_load":false,"index":"order_products","html":""},
                {"title":this.__t("ORDER.CLIENT"),"is_active":false,"is_load":false,"index":"order_client","html":""},
                {"title":this.__t("ORDER.REQUESTS"),"is_active":false,"is_load":false,"index":"order_requests","html":""},
                {"title":this.__t("ORDER.ACTION"),"is_active":false,"is_load":false,"index":"order_action","html":""},
                {"title":this.__t("ORDER.LOGS"),"is_active":false,"is_load":false,"index":"order_log","html":""}
            ]
		}
	},
	created() {
		EventBus.$on(this.event_name,res => this.work_click(res));
		EventBus.$on("reload_order_inside", this.reload_order);

	},


	methods : {
		close_mod() {
			this.close();
		},

		close() {
			this.order = this.default_order;
			this.is_show_modal = false;
            this.tabs[0].is_active = true;
		},

		get_tab_title (tab) {
			if(tab.count > 0) {
				return tab.title;
			}
			return tab.title;
		},

		set_active (obj) {
			for (let tab in this.tabs) {
				this.tabs[tab].is_active = false;
			}
			this.tabs[obj].is_active = true;
			EventBus.$emit('update:tabu', {type: this.tabs[obj].index, user_id: this.user_id});
		},

		work_click(ord_object) {
			this.is_show_modal = true;
			this.load_order(ord_object.id);
		},

		async reload_order(){
			this.__l(this.order,'reload_order');
			if(this.order.hasOwnProperty("id") && this.order.id > 0) {
				await this.load_order(this.order.id);
			}
		},

		async load_order(order_id) {
			this.is_load = true;
            this.order = this.default_order;

			await api.post('/internal/v1/catalog/orders/' + parseInt(order_id)).then(({data}) => {
				this.is_load = false;
				if (data.status === "operation_success") {
					this.order = data.data;
                    this.tabs[0].is_active = true;
				}
			}).catch(({response}) => {
				this.is_load = false;
				this.order = this.default_order;
				EventBus.$emit('show_toast', {err: response.data.message, type: "danger", title: response.data.status})
			});
		},
	},

	computed : {

        has_delivery() {
            if (this.order.hasOwnProperty("delivery_provider")) {
                let delivery_provider = this.order.delivery_provider;
                return delivery_provider?.can_call ?? true;
            }

            return false;
        },

		dialog_class_draw () {
			if(this.modal_position === "left") {
				return "modal-dialog-left order-modal-wide";
			}

			return "modal-dialog-right order-modal-wide";
		},

        order_added() {
            if(this.order.hasOwnProperty("times_data")) {
                return this.order.times_data.portal.db_added;
            }

            return "NOT_SET";
        },

        base_order() {
            if(this.order.hasOwnProperty("order")) {
                return this.order.order;
            }

            return {
                "order" : {
                    "id" : this.order.id,
                    "uniq_id" : "",
                    "order_code" : ""
                }
            };
        },

        order_code() {
            let code = '';
            if(this.base_order.hasOwnProperty("order_code")) {
                code = this.base_order.order_code;
            }

            if(this.base_order.hasOwnProperty("uniq_id")) {
                code += " | " + this.base_order.uniq_id
            }

            return code;
        },

        default_tabs() {
            let res = [
                {"title":this.__t("MAIN_SETTINGS"),"is_active":false,"is_load":false,"index":"order_info","html":""},
                {"title":this.__t("ORDER.PRODUCT"),"is_active":false,"is_load":false,"index":"order_products","html":""},
                {"title":this.__t("ORDER.CLIENT"),"is_active":false,"is_load":false,"index":"order_client","html":""},
                {"title":this.__t("ORDER.REQUESTS"),"is_active":false,"is_load":false,"index":"order_requests","html":""},
                {"title":this.__t("ORDER.ACTION"),"is_active":false,"is_load":false,"index":"order_action","html":""},
                {"title":this.__t("ORDER.LOGS"),"is_active":false,"is_load":false,"index":"order_log","html":""}
            ];

            if(this.has_delivery) {
                res.push( {"title":this.__t("ORDER.DELIVERY"),"is_active":false,"is_load":false,"index":"order_delivery","html":""});
            }

            if(!this.show_client_tab) {
                res = res.filter(tab => tab.index !== "order_client");
            }

            return res;
        },

		default_order () {
			return {
				id : 0,
                "order": {
                    "id": 0,
                    "uniq_id": "",
                    "order_code": "",
                    "transaction_id": "0",
                    "pickup_code": ""
                },
				uniq_id : "",
				order_code : "",
                times_data  : {
                    "market" : {
                        "added_human" : ""
                    }
                },
			}
		}

	}

}
</script>

<style scoped>

</style>

<style>
.order-modal-wide {
	max-width: 1700px;
}
</style>
